"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=15,o=(t="")=>{if(!t)return 0;const[e,r]=String(t).split(":");return Number(e)*60+Number(r??0)};exports.MINUTES_STEP=n;exports.toMinutes=o;
